import { useEffect, useState } from 'react';
import React from 'react';

import TawkMessengerReact from '@tawk.to/tawk-messenger-react';

import { useSelector } from 'third-party';

import { TAWK_PROPERTY_ID, TAWK_WIDGET_ID } from 'constants/common';

import { appSelectors } from 'selectors';

export const SupportChat = () => {
  const user = useSelector(appSelectors.user);
  const [tawkReady, setTawkReady] = useState(false);

  useEffect(() => {
    if (
      user?.id &&
      window?.Tawk_API?.login &&
      typeof window.Tawk_API.logout === 'function'
    ) {
      window.Tawk_API.logout();
    }
  }, [tawkReady, user?.id]);

  useEffect(() => {
    if (tawkReady && user?.id && window?.Tawk_API?.login) {
      window.Tawk_API.login({
        hash: user.chatHashId.toString(),
        userId: user.id.toString(),
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tawkReady, user?.id]);

  const showWidget = !!TAWK_PROPERTY_ID && !!TAWK_WIDGET_ID && !!user?.id;

  return showWidget ? (
    <TawkMessengerReact
      propertyId={TAWK_PROPERTY_ID as string}
      widgetId={TAWK_WIDGET_ID as string}
      onLoad={() => setTawkReady(true)}
    />
  ) : null;
};
